import { gameGroupModule } from '@/api'
import { ResWrap, service, IdRequestParam } from '@/utils/request'

/**
 * GameGroupAddRequest
 */
export interface IGameGroupAddRequest {
  /**
   * 分组名称
   */
  name?: string
}

/**
 * EmployeeGroupEditRequest
 */
export interface IGameGroupEditRequest {
  /**
   * 主键ID
   */
  id?: number
  /**
   * 分组名称
   */
  name?: string
}

/**
 * void
 *
 * Response«List«EmployeeGroupResponse»»
 */
export interface IGameGroupResponseParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: GameGroupResponse[]
  /**
   * 请求返回消息
   */
  msg?: string
}

/**
 * EmployeeGroupResponse
 */
export interface GameGroupResponse {
  /**
   * 主键ID
   */
  id?: string
  /**
   * 分组名称
   */
  name?: string
  /**
   * 排序值
   */
  sort?: number
}

/**
 * 新增平台分组
 */
export function addGameGroup(param: IGameGroupAddRequest): Promise<ResWrap<null>> {
  return service.post(`${gameGroupModule.gameGroupAddApi}`, param)
}
/**
 * 编辑平台分组
 *
 * @param param
 */
export function editGameGroup(param: IGameGroupEditRequest): Promise<ResWrap<null>> {
  return service.post(`${gameGroupModule.gameGroupEditApi}`, param)
}

/**
 * 删除平台分组
 *
 * @param param
 */
export function delGameGroup(param: IdRequestParam): Promise<ResWrap<null>> {
  return service.post(`${gameGroupModule.gameGroupDelApi}`, param)
}

/**
 * 列表平台分组
 */
export function gameGroupList(param: IGameGroupAddRequest): Promise<IGameGroupResponseParam> {
  return service.post(`${gameGroupModule.gameGroupListApi}`, param)
}
